const sum = (total: number, value?: number): number => {
    return Number((total + (Number(value) || 0)).toFixed(6));
};
export const sumArraySimple = (arr: number[]): number => {
    return arr.reduce(sum, 0);
};

const sumArray = (arr: any[], key: string) => {
    return arr.reduce((accumulator, item) => {
        return accumulator + Number(item[key] || 0);
    }, 0);
};

export default sumArray;
